import { useEffect, useMemo, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import LayoutSubmasterToUser from "../../components/layoutConfig/layoutSubmasterToUser";
import { setupAPIclient } from "../../services/setupAPIclient";
import LocalStorage from "../../helpers/localstorage";
import DataTable, { TableColumn } from "react-data-table-component";
import { Modal, OverlayTrigger, Tooltip, Card, Row, Col } from "react-bootstrap";
import { useUser } from "./UserProviderloginSubmaster";
import { Bar } from "react-chartjs-2";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
import { BsFileEarmarkText, BsPeople, BsCalendar3 } from "react-icons/bs";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, ChartTooltip, Legend);

interface History {
  id: number;
  data_vencimento: string;
  caminho_doc?: string;
}

interface UserAccess {
  id: number;
  user_id: number;
  name: string;
  email: string;
  can_view?: boolean;
}

interface Location {
  id: number;
  name: string;
}

interface Signatory {
  id?: number;
  email: string;
  user_id?: number | null;
}

interface ContractData {
  id: number;
  name?: string;
  caminho_doc?: string;
  data_vencimento?: string;
  history?: History[];
  locations?: Location[];
  users_access?: UserAccess[];
  signatories?: Signatory[];
}

interface DashboardDoc {
  id: number;
  name: string | null;
  data_vencimento: string;
  management_uploaddoc_reminder: { reminder_days: number }[];
  management_user_uploaddoc_access: { management_user: { name: string } }[];
  management_document_access: {
    management_company?: { name_company: string };
    management_region?: { name: string };
    management_unit?: { name: string };
  }[];
}

export default function HomeUserToSubmasterPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("name");

  const localStorage = new LocalStorage();
  const token = String(localStorage.getAuthTokenUserToSubmaster());
  const api = setupAPIclient(token);
  const { user } = useUser();

  const [contracts, setContracts] = useState<ContractData[]>([]);
  const [filteredContracts, setFilteredContracts] = useState<ContractData[]>([]);
  const [loading, setLoading] = useState(true);

  const [docs, setDocs] = useState<DashboardDoc[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  const [showModal, setShowModal] = useState(false);
  const [selectedContract, setSelectedContract] = useState<ContractData | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [signatories, setSignatories] = useState<Signatory[]>([{ email: "" }]);

  const [filterId, setFilterId] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const [filterDate, setFilterDate] = useState("");

  const hasPermission = !!user?.can_edit && !!user?.can_view;

  const handleGetContract = async () => {
    setLoading(true);
    try {
      const response = await api.post(`/management/get/contract`);
      const payload = response.data?.success ?? [];

      const mappedContracts: ContractData[] = payload.map((c: any) => ({
        id: c.id,
        name: c.name,
        caminho_doc: c.caminho_doc,
        data_vencimento: c.data_vencimento,
        history: c.management_history,
        signatories: c.management_signatories,
        users_access: c.management_user_uploaddoc_access?.map((u: any) => ({
          id: u.id,
          user_id: u.user_id,
          name: u.management_user.name,
          email: u.management_user.email,
          can_view: u.can_view,
        })),
        locations: c.management_document_access?.map((l: any) => ({
          id: l.id,
          name: `Local ${l.id}`,
        })),
      }));

      setContracts(mappedContracts);
      setFilteredContracts(mappedContracts);
    } catch (err) {
      console.error("Erro ao buscar contratos:", err);
      toast.error("Erro ao buscar contratos");
    } finally {
      setLoading(false);
    }
  };

  const loadDashboardData = async () => {
    try {
      const [resDocs, resUsers] = await Promise.all([
        api.post(`/management/get/dashboard`),
        api.post(`/management/get/users`),
      ]);
      setDocs(resDocs.data.docs || []);
      setUsers(resUsers.data?.success || []);
    } catch (error) {
      console.error("Erro ao buscar dashboard:", error);
    }
  };

  useEffect(() => {
    handleGetContract();
    loadDashboardData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  useEffect(() => {
    let temp = [...contracts];
    if (filterId.trim()) temp = temp.filter((c) => c.id.toString().includes(filterId.trim()));
    if (filterLocation.trim()) {
      temp = temp.filter((c) => (c.locations || []).some((l) => (l.name || "").toLowerCase().includes(filterLocation.toLowerCase())));
    }
    if (filterDate) {
      temp = temp.filter((c) => {
        if (!c.data_vencimento) return false;
        const d1 = new Date(c.data_vencimento);
        const d2 = new Date(filterDate);
        d1.setHours(0, 0, 0, 0);
        d2.setHours(0, 0, 0, 0);
        return d1.getTime() === d2.getTime();
      });
    }
    setFilteredContracts(temp);
  }, [filterId, filterLocation, filterDate, contracts]);

  const openModal = (contract: ContractData) => {
    setSelectedContract(contract);
    setPreviewUrl(contract.caminho_doc ? `https://alexios.com.br:9598/${contract.caminho_doc}` : null);
    const initialSignatories: Signatory[] = contract.signatories?.length
      ? contract.signatories
      : contract.users_access?.map((u) => ({ email: u.email, user_id: u.user_id })) ?? [{ email: "" }];
    setSignatories(initialSignatories);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedContract(null);
    setPreviewUrl(null);
    setSignatories([{ email: "" }]);
  };

  const handleViewHistory = (caminho_doc?: string) => {
    if (caminho_doc) setPreviewUrl(`https://alexios.com.br:9598/${caminho_doc}`);
  };

  const columns: TableColumn<ContractData>[] = useMemo(() => {
    const renderBadge = (content: string | number, color: string) => <span className={`badge bg-${color}`}>{content}</span>;

    const renderVencimento = (date?: string) => {
      if (!date) return renderBadge("-", "secondary");
      const d = new Date(date);
      if (isNaN(d.getTime())) return renderBadge(date, "warning");
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const past = d < today;
      return renderBadge(d.toLocaleDateString("pt-BR"), past ? "danger" : "success");
    };

    const renderUsersAccess = (usersAccess?: UserAccess[]) => {
      if (!usersAccess?.length) return "-";
      return (
        <div style={{ display: "flex", gap: 4 }}>
          {usersAccess.map((u) => (
            <OverlayTrigger key={u.id} placement="top" overlay={<Tooltip>{u.email}</Tooltip>}>
              <div
                className="d-flex justify-content-center align-items-center text-white"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "50%",
                  backgroundColor: "rgb(93, 173, 226)",
                  fontSize: "0.85rem",
                  fontWeight: 600,
                }}
              >
                {u.name[0].toUpperCase()}
              </div>
            </OverlayTrigger>
          ))}
        </div>
      );
    };

    const renderActions = (row: ContractData) => (
      <div className="d-flex gap-2">
        <OverlayTrigger placement="top" overlay={<Tooltip>Ver detalhes</Tooltip>}>
          <button className="btn btn-sm btn-outline-primary rounded-pill shadow-sm" onClick={() => openModal(row)}>
            <i className="bi bi-eye"></i>
          </button>
        </OverlayTrigger>
        <OverlayTrigger placement="top" overlay={<Tooltip>Download</Tooltip>}>
          <a className="btn btn-sm btn-outline-secondary rounded-pill shadow-sm" href={row.caminho_doc ? `https://alexios.com.br:9598/${row.caminho_doc}` : "#"} target="_blank" rel="noreferrer">
            <i className="bi bi-download"></i>
          </a>
        </OverlayTrigger>
      </div>
    );

    return [
      { name: "ID", selector: (row) => row.id, sortable: true, width: "80px", center: true, cell: (row) => renderBadge(row.id, "dark") },
      { name: "Nome", selector: (row) => row.name || "-", sortable: true, cell: (row) => <span className="fw-bold">{row.name || "-"}</span> },
      { name: "Vencimento", selector: (row) => row.data_vencimento, sortable: true, width: "150px", cell: (row) => renderVencimento(row.data_vencimento) },
      { name: "Acessos", selector: (row) => row.users_access?.length || 0, sortable: true, cell: (row) => renderUsersAccess(row.users_access) },
      { name: "Ações", cell: renderActions, width: "120px", center: true },
    ];
  }, []);

  const chartDataMap: Record<string, number> = {};
  docs.forEach((d) => {
    d.management_document_access.forEach((access) => {
      const key = [
        access.management_company?.name_company ?? "",
        access.management_region?.name ?? "",
        access.management_unit?.name ?? "",
      ]
        .filter(Boolean)
        .join(" / ");
      if (!key) return;
      chartDataMap[key] = (chartDataMap[key] || 0) + 1;
    });
  });

  const chartLabels = Object.keys(chartDataMap);
  const chartValues = Object.values(chartDataMap);

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        type: "bar" as const,
        label: "Contratos",
        data: chartValues,
        borderRadius: 10,
        backgroundColor: "rgba(93, 173, 226, 0.65)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" as const },
      title: { display: true, text: "Performance por Empresa / Região / Unidade" },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          callback: (value: number | string) => {
            const label = chartLabels[Number(value)] || "";
            return label.length > 18 ? `${label.slice(0, 18)}...` : label;
          },
        },
      },
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  const totalContracts = docs.length;
  const totalUsers = users.length;
  const expiringContracts = docs.filter((d) => {
    const reminderDays = d.management_uploaddoc_reminder?.[0]?.reminder_days ?? 0;
    const diffDays = (new Date(d.data_vencimento).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= reminderDays;
  }).length;

  const eventsForSelectedDate = useMemo(() => {
    return docs.filter((d) => {
      const date = new Date(d.data_vencimento);
      return (
        date.getUTCFullYear() === selectedDate.getUTCFullYear() &&
        date.getUTCMonth() === selectedDate.getUTCMonth() &&
        date.getUTCDate() === selectedDate.getUTCDate()
      );
    });
  }, [docs, selectedDate]);

  return (
    <LayoutSubmasterToUser>
      {hasPermission ? (
        <div className="content mt-3">
          <Row className="mb-3">
            <Col md={4} className="mb-3">
              <Card className="dashboard-grid-card p-3 h-100">
                <div className="dashboard-stat">
                  <div className="dashboard-stat-icon"><BsFileEarmarkText size={18} /></div>
                  <div>
                    <div className="text-muted small">Contratos</div>
                    <div className="h4 mb-0">{totalContracts}</div>
                  </div>
                </div>
              </Card>
            </Col>
            <Col md={4} className="mb-3">
              <Card className="dashboard-grid-card p-3 h-100">
                <div className="dashboard-stat">
                  <div className="dashboard-stat-icon"><BsPeople size={18} /></div>
                  <div>
                    <div className="text-muted small">Signatários</div>
                    <div className="h4 mb-0">{totalUsers}</div>
                  </div>
                </div>
              </Card>
            </Col>
            <Col md={4} className="mb-3">
              <Card className="dashboard-grid-card p-3 h-100">
                <div className="dashboard-stat">
                  <div className="dashboard-stat-icon"><BsCalendar3 size={18} /></div>
                  <div>
                    <div className="text-muted small">Próximos a vencer</div>
                    <div className="h4 mb-0">{expiringContracts}</div>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col md={8} className="mb-3">
              <Card className="dashboard-grid-card p-3 h-100">
                <div className="dashboard-section-title mb-2">Visão de Contratos</div>
                <div style={{ minHeight: 360 }}>
                  <Bar data={chartData} options={chartOptions} />
                </div>
              </Card>
            </Col>

            <Col md={4} className="mb-3">
              <Card className="dashboard-grid-card p-3 h-100 dashboard-mini-calendar">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div className="dashboard-section-title">Agenda rápida</div>
                  <Link to="/AgendaPageSubmaster" className="btn btn-sm modern-primary-btn">Abrir agenda</Link>
                </div>

                <Calendar
                  locale="pt-BR"
                  onChange={(v) => setSelectedDate(v as Date)}
                  value={selectedDate}
                  formatDay={(_, date) => format(date, "dd", { locale: ptBR })}
                  tileContent={({ date }) => {
                    const hasEvent = docs.some((d) => {
                      const x = new Date(d.data_vencimento);
                      return (
                        x.getUTCFullYear() === date.getUTCFullYear() &&
                        x.getUTCMonth() === date.getUTCMonth() &&
                        x.getUTCDate() === date.getUTCDate()
                      );
                    });
                    return hasEvent ? <span style={{ color: "rgb(93, 173, 226)", fontSize: 11 }}>●</span> : null;
                  }}
                />

                <div className="mt-3">
                  <div className="small text-muted mb-2">
                    {format(selectedDate, "dd/MM/yyyy", { locale: ptBR })} - {eventsForSelectedDate.length} evento(s)
                  </div>
                  <div className="d-flex flex-column gap-2">
                    {eventsForSelectedDate.slice(0, 3).map((event) => (
                      <div className="agenda-event" key={event.id}>
                        <div className="fw-semibold">{event.name || "Sem nome"}</div>
                      </div>
                    ))}
                    {eventsForSelectedDate.length === 0 && <div className="agenda-event">Nenhum evento.</div>}
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      ) : (
        <>
          <div className="card mt-3" style={{ padding: "15px" }}>
            <h3>Contratos</h3>

            <div className="d-flex gap-2 mb-3">
              <input type="text" className="form-control" placeholder="Filtrar por ID" value={filterId} onChange={(e) => setFilterId(e.target.value)} />
              <input type="text" className="form-control" placeholder="Filtrar por Local" value={filterLocation} onChange={(e) => setFilterLocation(e.target.value)} />
              <input type="date" className="form-control" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} />
            </div>

            <DataTable columns={columns} data={filteredContracts} progressPending={loading} pagination noDataComponent="Nenhum registro para exibir" highlightOnHover striped responsive />
          </div>

          <Modal show={showModal} onHide={closeModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Detalhes do Contrato {selectedContract?.name}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {previewUrl ? <iframe src={previewUrl} width="100%" height="400px" title="Preview do Documento" /> : <p>Nenhum documento disponível</p>}

              <h5 className="mt-3">Histórico de Contratos</h5>
              {selectedContract?.history?.length ? (
                <ul className="list-group mb-3">
                  {selectedContract.history.map((h) => (
                    <li key={h.id} className="list-group-item d-flex justify-content-between align-items-center">
                      <span>{new Date(h.data_vencimento).toLocaleDateString("pt-BR")}</span>
                      <div className="d-flex gap-2">
                        {h.caminho_doc && (
                          <>
                            <a href={`https://alexios.com.br:9598/${h.caminho_doc}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary">Download</a>
                            <button className="btn btn-sm btn-outline-success" onClick={() => handleViewHistory(h.caminho_doc)}>Ver</button>
                          </>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Não há histórico de documentos.</p>
              )}

              <h5 className="mt-3">Integrantes</h5>
              {signatories.map((s, idx) => (
                <div key={idx} className="mb-2">
                  <input type="email" className="form-control" value={s.email} readOnly />
                </div>
              ))}
            </Modal.Body>

            <Modal.Footer>
              <button className="btn btn-secondary" onClick={closeModal}>Fechar</button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </LayoutSubmasterToUser>
  );
}
